import { render, staticRenderFns } from "./rfmStatistics.vue?vue&type=template&id=32f169ba&"
import script from "./rfmStatistics.vue?vue&type=script&lang=js&"
export * from "./rfmStatistics.vue?vue&type=script&lang=js&"
import style0 from "./rfmStatistics.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports